// =============================================================
// Tối ưu ảnh chữ kí (loại PAPER) trước khi gửi lên BE.
// Port từ mobile-app-v2 (src/modules/signature/signature.image.ts):
// resize + nén lặp cho tới khi base64 đủ nhẹ, tránh PayloadTooLargeError.
// =============================================================

const MAX_WIDTH = 1280;
const MIN_WIDTH = 700;
// base64 dài ~1.37 lần số byte. Mốc ~140k ký tự ~= 100KB ảnh.
const TARGET_BASE64_LENGTH = 140_000;
const MAX_PASSES = 4;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Không xử lý được ảnh chữ kí"));
    };
    img.src = url;
  });

/**
 * Trả về data-uri base64 (JPEG) đã nén của ảnh chữ kí được chọn.
 * Tự hạ kích thước/chất lượng dần cho tới khi đủ nhẹ.
 */
export const optimizeSignatureImageToBase64 = async (file) => {
  const img = await loadImage(file);
  const naturalWidth = img.naturalWidth || img.width;
  const naturalHeight = img.naturalHeight || img.height;

  if (!naturalWidth || !naturalHeight) {
    throw new Error("Không xử lý được ảnh chữ kí");
  }

  let targetWidth = Math.min(naturalWidth, MAX_WIDTH);
  let quality = 0.6;
  let lastDataUri = null;

  for (let pass = 0; pass < MAX_PASSES; pass += 1) {
    const width = Math.round(targetWidth);
    const height = Math.round((naturalHeight / naturalWidth) * width);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    // JPEG không có kênh alpha -> tô nền trắng để vùng trong suốt không thành đen
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(img, 0, 0, width, height);

    lastDataUri = canvas.toDataURL("image/jpeg", quality);

    if (lastDataUri.length <= TARGET_BASE64_LENGTH) break;

    // Còn nặng -> hạ tiếp kích thước + chất lượng
    targetWidth = Math.max(MIN_WIDTH, Math.round(targetWidth * 0.8));
    quality = Math.max(0.4, quality - 0.1);
  }

  if (!lastDataUri) {
    throw new Error("Không xử lý được ảnh chữ kí");
  }

  return lastDataUri;
};
